export default __webpack_public_path__ + "static/media/custom1.af6ce880.jpg";